export default __webpack_public_path__ + "static/media/IMG-2729.47bde5e7.jpg";